import { Component, Input } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { SupplyPointAttribute } from 'src/app/spatial-modeller/models/supply-point-attribute';

import { InputControlType } from '../../../models/dynamic-form';

const getControlType = {
  Textbox: 'text',
  NumericTextbox: 'number',
  DatePicker: 'date'
};
const DECIMAL_OR_EXPONENT_PATTERN = /[.,eE]/;
const DECIMAL_OR_EXPONENT_KEY_PATTERN = /^[.,eE]$/;

@Component({
  selector: 'atlas-input',
  templateUrl: './atlas-input.component.html',
  styleUrls: ['./atlas-input.component.less'],
  standalone: false
})
export class AtlasInputComponent {
  formControl: SupplyPointAttribute;

  @Input()
  set control(theControl: SupplyPointAttribute) {
    this.formControl = theControl;
    this.controlType =
      getControlType[this.formControl.displayType as InputControlType];
  }

  formGroup: UntypedFormGroup;
  controlType: string;

  get isInteger(): boolean {
    return this.formControl?.type === 'Integer';
  }

  integerError(): boolean {
    if (!this.isInteger) {
      return false;
    }

    const control = this.formGroup.get(this.formControl.name);
    return (
      control !== null &&
      control.hasError('pattern') &&
      (control.dirty || control.touched)
    );
  }

  onBeforeInput(event: InputEvent): void {
    const text =
      event.data ?? event.dataTransfer?.getData('text/plain') ?? undefined;
    this.preventDecimalInput(event, text);
  }

  onKeydown(event: KeyboardEvent): void {
    if (this.isInteger && DECIMAL_OR_EXPONENT_KEY_PATTERN.test(event.key)) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent): void {
    this.preventDecimalInput(event, event.clipboardData?.getData('text'));
  }

  private preventDecimalInput(
    event: Event,
    text: string | null | undefined
  ): void {
    if (this.isInteger && DECIMAL_OR_EXPONENT_PATTERN.test(text ?? '')) {
      event.preventDefault();
    }
  }

  constructor(private parentFormDirective: FormGroupDirective) {
    this.formGroup = this.parentFormDirective.control;
  }
}
